<div class="pane-content" *ngIf="isDataAvailable">
  <div class="card">
    <div class="card-header">
      <div class="align-items-center">
        <div>
          <h1 class="p-0">{{selectedMessage.subject}}</h1>
        </div>
      </div>
    </div>
    <div class="card-body bg-light" *ngIf="isReplyVisible" style="padding:1rem">
      <ng-container>
        <button kendoButton class="btn bg-green mr-3 border-white" type="button" data-toggle="dropdown"
          [disabled]="type === 'DELETED' || selectedMessage.fromDirectAddress !== null" (click)="reply()"
          attr.aria-label="{{ 'REPLY' | translate }}">
          {{ 'REPLY' | translate }}<i class="fas fa-reply" aria-hidden="true"></i>
        </button>
      </ng-container>
      <ng-container>
        <button kendoButton class="btn bg-blue mr-3 border-white" type="button" data-toggle="dropdown"
          [disabled]="selectedMessage.to.length < 2 || type === 'DELETED' || selectedMessage.fromDirectAddress !== null"
          (click)="replyAll()" attr.aria-label="{{ 'REPLY-ALL' | translate }}">
          {{ 'REPLY-ALL' | translate }}<i class="fas fa-reply-all" aria-hidden="true"></i>
        </button>
      </ng-container>
    </div>
    <div class="content-background">
      <div class="row align-items-start">
        <div class="col-sm-2 col-xl-1 my-auto" style="max-width:90px;">
          <img alt="{{'PHOTO' | translate}}" *ngIf="hasImage && imageLoaded" class="avatar-custom" [src]="url">
          <kendo-avatar *ngIf="!hasImage && imageLoaded && userInitials" class="avatar-custom" shape="circle"
            initials="{{userInitials|uppercase}}">
          </kendo-avatar>
        </div>
        <div class="col-sm-6 col-xl-7">
          <div><span [ngClass]="{'label-detail-wide': type !== 'SENT', 'label-detail': type === 'SENT'}">{{ 'FROM' |
              translate }}</span><strong>{{selectedMessage.from}}</strong></div>
          <div *ngIf="type !== 'SENT' && selectedMessage.fromOrganization"><span class='label-detail-wide'>{{
              'FROM-ORGANIZATION' | translate}}</span><strong>{{selectedMessage.fromOrganization}}</strong>
          </div>
          <div><span [ngClass]="{'label-detail-wide': type !== 'SENT', 'label-detail': type === 'SENT'}">{{ 'TO' |
              translate }}</span>
            <span class="to-address" *ngFor="let to of selectedMessage.to;let i = index;"
              [innerHTML]="to.name | cleanAddress:i:to.directMessageStatus">
            </span>
          </div>
        </div>
        <div class="col-sm-3 col-xl-3">{{ 'MESSAGE-DATE' | translate }}<br /><strong>
            {{intl.formatDate(intl.parseDate(selectedMessage.sentOn), 'g')}}</strong>
        </div>
      </div>
    </div>
    <div class="content-background" *ngIf="!messageReplyOpened" style="padding-top:0">
      <div class="row align-items-start message-body-content" [innerHTML]="body">
      </div>
    </div>
    <div class="card-body bg-light" style="padding:1rem">
      <app-document [memberId]="" [caseId]="" [taskId]="" [taskDefinitionId]="" [bpmId]=""
        [messageId]="selectedMessage.id" [allowAdd]="false">
      </app-document>
    </div>
    <div class="content-background" *ngIf="messageReplyOpened">
      <app-message-reply #messageReply [messageReplyOpened]="messageReplyOpened" [messageToReply]="selectedMessage"
        [messageList]="messageList" [all]="all" (saving)="savingMessage=$event;"></app-message-reply>
      <kendo-dialog-actions
        style="margin-right:-30px;border-top: none;margin-top:-5px;margin-bottom:-15px;margin-left:30px">
        <button kendoButton (click)="messageReplyOpened = false">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick #submitButton kendoButton type="button"
          [disabled]="!messageReply.formValid() || savingMessage"
          (click)="messageReply.send(); messageReplyOpened = false;">
          {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
        </button>
      </kendo-dialog-actions>
    </div>
  </div>
</div>